import { render, staticRenderFns } from "./Settingpage.vue?vue&type=template&id=11b3f22f&"
import script from "./Settingpage.vue?vue&type=script&lang=js&"
export * from "./Settingpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports